module.exports = __webpack_public_path__ + "static/media/recurring_campaign_description.6513197c.png";